import { Tabs } from "antd";
import React, { useState } from "react";
import SalesList from "./SalesList";
import ItemWiseSalesList from "./ItemWiseSalesList";
import CustomerWiseSales from "./CustomerWiseSales";
import CorporateWiseSales from "./CorporateWiseSales";

export default function MainSalesReport() {
  const [tabChange, setTabChange] = useState(null);

  const handleTabChange = (value) => {
    setTabChange(value);
  };
  const items = [
    {
      key: "Center Wise Sales",
      label: (
        <div className="text-center" style={{ color: "#46604A" }}>
          Center Wise Sales
        </div>
      ),
      children: <SalesList tabChange={tabChange} />,
    },
    {
      key: "Product Wise Sales Summary",
      label: (
        <div className="text-center" style={{ color: "#46604A" }}>
          Product Wise Sales Summary
        </div>
      ),
      children: <ItemWiseSalesList tabChange={tabChange} />,
    },
    {
      key: "Customer Wise Sales Summary",
      label: (
        <div className="text-center" style={{ color: "#46604A" }}>
          Customer Wise Sales Summary
        </div>
      ),
      children: <CustomerWiseSales tabChange={tabChange} />,
    },
    {
      key: "Corporate Wise Sales Summary",
      label: (
        <div className="text-center" style={{ color: "#46604A" }}>
          Corporate Wise Sales Summary
        </div>
      ),
      children: <CorporateWiseSales tabChange={tabChange} />,
    },
  ];
  return (
    <>
      <div className="shadow-sm rounded">
        <Tabs
          onChange={handleTabChange}
          className="px-4 mt-4 custom-tabs"
          defaultActiveKey="Purchase Order List"
          items={items}
        />
      </div>
    </>
  );
}
